export default __webpack_public_path__ + "static/media/arg.62e6b2b7.svg";